"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Helper to call a given function, only once
var _default = function _default() {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
};

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/icons/~/@vds-core/utilities/dist/cjs/utils/once.js
// module id = 1446
// module chunks = 0